import { useContext, useEffect, useRef } from "react";
import { NotificationsContext } from "../../context/NotificationsContext";
import * as elementUtils from "../../utils/elementUtils";

import "./notifications-panel.css";
import { wait } from "../../utils/genericUtils";

export default function NotificationsPanel() {
  const { notifications, notificationCount, deleteNotification } = useContext(NotificationsContext);

  const ids = useRef(new Set());
  const newNotifications = useRef(new Set()); // Track new notifications separately

  useEffect(() => {
    // Move new notification IDs to the main set after render
    newNotifications.current.forEach((id) => ids.current.add(id));
    newNotifications.current.clear();
  });

  function RenderNotifications() {
    return notifications.map((notification) => {
      const isNew = !ids.current.has(notification.id);
      if (isNew) newNotifications.current.add(notification.id); // Mark as new before adding it later

      return <Notification key={`${notification.id}-${notificationCount}`} {...notification} deleteFunc={deleteNotification} isNew={isNew} />;
    });
  }

  return (
    <section className="notifications-panel">
      <div className="notifications-panel-inner">{RenderNotifications()}</div>
    </section>
  );
}

const notificationProps = {
  id: "",
  title: "",
  text: "",
  isNew: false,
  deleteFunc: () => {},
};
function Notification(props = notificationProps) {
  const animationTime = 400;

  useEffect(() => {
    //animate
    AnimateNotficationShow();
  }, []);

  function AnimateNotficationShow() {
    const notification_item = document.querySelector("#" + `notification-item-${props.id}`);

    //move modal inner from above center to  center vertically
    let current_bottom = window.getComputedStyle(notification_item).bottom;

    //fade in
    if (props.isNew === true) {
      elementUtils.fadeIn(notification_item, animationTime, 1, "flex");
    }

    let next_bottom = parseInt(current_bottom) < 0 ? "0px" : parseInt(current_bottom) + 100 + "px";
    elementUtils.moveElement(notification_item, animationTime, { bottom: current_bottom }, { bottom: next_bottom });
  }

  function AnimateNotficationClose() {
    const notification_item = document.querySelector("#" + `notification-item-${props.id}`);

    //fade out
    elementUtils.fadeOut(notification_item, animationTime, 1);

    //move notification from start to left off screemn
    elementUtils.moveElement(notification_item, animationTime, { left: "0px" }, { left: "-400px" });

    wait(animationTime, () => {
      if (props.deleteFunc) props.deleteFunc(props.id);
    });
  }

  return (
    <div id={`notification-item-${props.id}`} className="notification-item">
      {/* TOP */}
      <div className="notification-item-top">
        <h4 className="notification-item-top-title">{props.title}</h4>
        <button className="notification-item-close-button" onClick={AnimateNotficationClose}>
          X
        </button>
      </div>
      {/* Content */}
      <p className="notification-item-text">{props.text}</p>
    </div>
  );
}
